import Vue from "vue";
import { NumericTextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
Vue.use(NumericTextBoxPlugin);
export default Vue.extend({
    props: {
        id: {
            type: String,
            required: true
        },
        format: {
            type: String,
            required: false,
            default: "n2"
        },
        placeholder: {
            type: String,
            required: false,
            default: ""
        },
        type: {
            type: String,
            required: false,
            default: "text"
        },
        enabled: {
            type: Boolean,
            required: false,
            default: true
        },
        value: {
            type: Number,
            required: false
        },
        cssClass: {
            type: String,
            required: false,
            default: ""
        }
    },
    data() {
        return {
            dataMsgContainerId: `${this.id}-error`
        };
    },
    methods: {
        emitValue(value) {
            this.$emit("input", value);
        }
    }
});
